module.exports = __webpack_public_path__ + "static/media/Gate.svg";